<div
  class="box"
  [class]="{
    'box--active': store.activeBox()?.id === box.id
  }"
  (click)="store.selectBox(box.id)"
>
  <div class="box__number">№ {{ index + 1 }}</div>
  <div class="box__label">{{ box.option?.label }}</div>
  <div class="box__value">{{ box.option?.value }}</div>
</div>
